import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgIf, CommonModule } from '@angular/common';
import { FitnessPlanService } from '../fitness-plan.service';

@Component({
  selector: 'app-fitness-member-basic-details',
  standalone: true,
  imports: [NgIf, CommonModule],
  templateUrl: './fitness-member-basic-details.component.html',
  styleUrl: './fitness-member-basic-details.component.css',
})
export class FitnessMemberBasicDetailsComponent implements OnInit {
  @Input() memberDetail: any;
  @Input() currentStep: number = 1;
  @Input() totalSteps: number = 1;
  @Input() isEditMode: boolean = false;
  @Input() isCurrentStepValid: boolean = true;

  @Output() nextStepClicked = new EventEmitter<void>();
  @Output() createPlanClicked = new EventEmitter<void>();

  memberDetails: any = {};
  actualWeight: any = 0;
  bmiValue: any = null;

  constructor(private fitnessService: FitnessPlanService) {}

  ngOnInit(): void {
    // console.log(
    //   'fitness-member-basic-details component initialized with memberDetail:',
    //   this.memberDetail
    // );
    this.getMemberDetails(this.memberDetail);
    this.getVitalData(this.memberDetail);
  }

  getMemberDetails(id: any) {
    this.fitnessService.getMemberDetails(id).subscribe((response) => {
      this.memberDetails = response;
      this.memberDetails = this.memberDetails.result;
      // console.log(
      //   'Loaded member details:',
      //   this.memberDetails
      // );
      // console.log('Member age:', this.memberDetails?.age);
    });
  }

  getVitalData(id: any) {
    this.fitnessService.getVital(id).subscribe((response) => {
      this.actualWeight = response;
      if (this.actualWeight?.result?.bmiData !== null) {
        // Capture BMI value
        this.bmiValue = this.actualWeight.result.bmiData.bmi;
        this.actualWeight = this.actualWeight.result.bmiData.weight_lb;
        // console.log('BMI value loaded:', this.bmiValue);
      } else {
        this.actualWeight = 0;
        this.bmiValue = null;
      }
    });
  }

  onNextStep() {
    this.nextStepClicked.emit();
  }

  onCreatePlan() {
    this.createPlanClicked.emit();
  }
}
